"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolkitItemDto = void 0;
const LocationDto_1 = require("../locations/LocationDto");
class ToolkitItemDto {
    constructor(params) {
        this.toolkitItemType = "";
        this.name = "";
        this.url = "";
        this.toolkitItemIconFileName = "";
        this.toolkitItemIconContentType = "";
        this.toolkitItemIconUpdatedAt = "";
        this.createdAt = "";
        this.updatedAt = "";
        this.position = "";
        this.toolkitItemIconAndroidFileName = "";
        this.toolkitItemIconAndroidContentType = "";
        this.toolkitItemIconAndroidUpdatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.locationId = params.locationId;
        this.toolkitItemType = params.toolkitItemType;
        this.name = params.name;
        this.url = params.url;
        this.toolkitItemIconFileName = params.toolkitItemIconFileName;
        this.toolkitItemIconContentType = params.toolkitItemIconContentType;
        this.toolkitItemIconFileSize = params.toolkitItemIconFileSize;
        this.toolkitItemIconUpdatedAt = params.toolkitItemIconUpdatedAt;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.position = params.position;
        this.toolkitItemIconAndroidFileName = params.toolkitItemIconAndroidFileName;
        this.toolkitItemIconAndroidContentType =
            params.toolkitItemIconAndroidContentType;
        this.toolkitItemIconAndroidFileSize = params.toolkitItemIconAndroidFileSize;
        this.toolkitItemIconAndroidUpdatedAt
            = params.toolkitItemIconAndroidUpdatedAt;
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
    }
}
exports.ToolkitItemDto = ToolkitItemDto;
//# sourceMappingURL=ToolkitItemDto.js.map